var pagination = {
	backwardText: "föregående sida",
	forwardText: "nästa sida",
	pageRangeText: "Sida {current} av {total}",
	itemsPerPageText: "Objekt per sida",
	itemRangeText: "{start}-{end} av {total} objekt",
	pageNumberText: "aktuell sida"
};
var searchPlaceholder = "Sök ...";
var svTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { svTranslations as default, pagination, searchPlaceholder };
